import { Link } from 'gatsby';
import OutboundLink from '../components/OutboundLink';

export const getLinkTag = (uri, defaultTag = 'button') => {
  if (!uri) {
    return {
      tag: defaultTag,
      tagProps: {},
    };
  }
  const isExternalLink = uri.indexOf('http') >= 0;
  const Tag = isExternalLink ? OutboundLink : Link;
  const internalUri = uri[0] === '/' ? uri : `/${uri}`;
  const tagProps = isExternalLink ? { href: uri } : { to: internalUri };
  return ({
    isExternalLink,
    tag: Tag,
    tagProps,
  });
};

export const trackEvent = (category, action, label) => {
  if (!window || !window.ga) {
    return;
  }

  const eventLabel = label || window.location.pathname;

  // eslint-disable-next-line no-undef
  ga('send', 'event', category, action, eventLabel);
};

export const trackFormSubmit = (formId) => {
  if (typeof dataLayer !== 'undefined') {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'mktoLead',
      mktoFormId: formId,
    });
  }
};

export const polyfillRepeatIE = () => {
  if (!String.prototype.repeat) {
    String.prototype.repeat = (count) => {
      if (this == null) { throw new TypeError(`can't convert ${this} to object`); }

      let str = `${this}`;
      // To convert string to integer.
      count = +count;
      // Check NaN
      if (count !== count) { count = 0; }

      if (count < 0) { throw new RangeError('repeat count must be non-negative'); }

      if (count === Infinity) { throw new RangeError('repeat count must be less than infinity'); }

      count = Math.floor(count);
      if (str.length === 0 || count === 0) { return ''; }

      // Ensuring count is a 31-bit integer allows us to heavily optimize the
      // main part. But anyway, most current (August 2014) browsers can't handle
      // strings 1 << 28 chars or longer, so:
      if (str.length * count >= 1 << 28) { throw new RangeError('repeat count must not overflow maximum string size'); }

      const maxCount = str.length * count;
      count = Math.floor(Math.log(count) / Math.log(2));
      while (count) {
        str += str;
        count--;
      }
      str += str.substring(0, maxCount - str.length);
      return str;
    };
  }
};


// For mapping through multiple sections (for example check Cards component)
export const getObjectProperty = (cases, key, defaultCase) => {
  if (cases.hasOwnProperty(key)) {
    return cases[key];
  }
  return defaultCase;
};


export const windowExists = typeof window !== 'undefined';
